import type { CutawayOp } from './types';
export interface CutawayDraft { removed?: boolean; sceneId?: string; deltaS?: number }
export function cutawayOperations(drafts: Record<number, CutawayDraft>): CutawayOp[] {
  return Object.entries(drafts).flatMap(([key, draft]): CutawayOp[] => {
    const index = Number(key);
    if (draft.removed) return [{ index, op: 'remove' }];
    return [
      ...(draft.sceneId ? [{ index, op: 'replace' as const, sceneId: draft.sceneId }] : []),
      ...(draft.deltaS ? [{ index, op: 'shift' as const, deltaS: draft.deltaS }] : []),
    ];
  });
}
